<template>
    <v-card hover flat>
        <v-form ref="form" v-model="valid" lazy-validation enctype="multipart/form-data">
          <v-card-title>
            <h3 class="headline mb-0"><span style="color: #9C1A1A">Asignar Rol</span></h3>
          </v-card-title>
          <v-card-text>

            <v-flex xs12>
                <v-autocomplete
                    v-model="form.role_user"
                    :disabled="isUpdating"
                    :items="roles"
                    filled
                    chips
                    color="blue-grey lighten-2"
                    label="Roles"
                    item-text="name"
                    item-value="slug"
                    multiple
                    required
                    :rules="[v => !!v || 'Rol es requerido']"
                >
                    <template v-slot:selection="data">
                        <v-chip
                            :selected="data.selected"
                            close
                            class="chip--select-multi"
                            @input="remove(data.item)"
                        >
                        {{ data.item.name }}
                        </v-chip>
                    </template>
                    <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-tile-content v-text="data.item"></v-list-tile-content>
                        </template>
                        <template v-else>
                            <v-list-tile-content>
                                <v-list-tile-title v-html="data.item.name"></v-list-tile-title>
                            </v-list-tile-content>
                        </template>
                    </template>
                </v-autocomplete>
            </v-flex>

          </v-card-text>
          <v-card-actions>
            <v-btn @click="cerrarDialog()">Cerrar</v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" class="primary" @click="submit">Asignar</v-btn>
          </v-card-actions>
        </v-form>
    </v-card>
</template>
<script>
import Form from 'vform'
import axios from 'axios'

export default {

    props: {
        id: {
            type: Number,
            required: true
        },
        loading: {
            type: Boolean,
            required: true
        }
    },

    watch: {
      isUpdating (val) {
        if (val) {
          setTimeout(() => (this.isUpdating = false), 3000)
        }
      },
    },

    data: () => ({
        roles: [],
        autoUpdate: true,
        valid: false,
        isUpdating: false,
        form: new Form({
            user_id: null,
            role_user: [],
        }),
        formOld: new Form({
            user_id: null,
            role_user: [],
        })
    }),

    mounted () {
        this.getAllRoles()
    },

    methods: {

        async getAllRoles () {
            this.$emit('loadingResponse', true)
            await axios.get(`/api/roles/admin/getAllRoleUser/${this.id}`)
              .then(res => {
                  //console.log(res, 'data')
                  this.roles = res.data.allroles;
                  this.form.role_user = res.data.roleuser;
              })
              .finally(() => this.$emit('loadingResponse', false));
        },

        async submit () {
            if (this.$refs.form.validate()) {
                this.form.user_id = this.id
                this.$emit('loadingResponse', true)
                await axios.post(`/api/roles/admin/update-user-role`, this.form)
                    .then(res => {
                        this.$store.dispatch('responseMessage', {
                            type: 'success',
                            text: 'Roles asignados con exito!'
                        })
                    })
                    .catch(error => {
                        console.log(error.response)
                    })
                    .finally(() => this.$emit('loadingResponse', false));
                this.cerrarDialog()
            }
        },

        cerrarDialog () {
            this.$emit('closeDialogUserRole')
            this.$nextTick(() => {
                // this.$refs.form.resetValidation()
                this.$emit('loadingResponse', false)
            })
        },

        remove (item) {
            const index = this.form.role_user.indexOf(item.slug)
            if (index >= 0) this.form.role_user.splice(index, 1)
        },

    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admin/formRoleUser.vue